const WA_URL = `https://wa.me/33784678802?text=${encodeURIComponent("Bonjour, je souhaite un devis pour mon site internet")}`;

const WhatsAppIcon = () => (
  <svg viewBox="0 0 32 32" width="24" height="24" fill="currentColor" aria-hidden="true">
    <path d="M16 3C8.8 3 3 8.7 3 15.8c0 2.5.7 4.9 2 7L3 29l6.4-1.9c2 1.1 4.3 1.7 6.6 1.7 7.2 0 13-5.7 13-12.9S23.2 3 16 3zm0 23.6c-2 0-4-.6-5.7-1.6l-.4-.2-3.8 1.1 1.1-3.6-.3-.4c-1.2-1.8-1.8-3.8-1.8-5.9C5.2 9.9 10 5.2 16 5.2s10.8 4.7 10.8 10.6S22 26.6 16 26.6zm5.9-7.9c-.3-.2-1.9-.9-2.2-1-.3-.1-.5-.2-.7.2-.2.3-.8 1-1 1.2-.2.2-.4.2-.7.1-.3-.2-1.4-.5-2.6-1.6-1-.9-1.6-1.9-1.8-2.2-.2-.3 0-.5.1-.7l.5-.6c.2-.2.2-.4.3-.6.1-.2 0-.4 0-.6l-1-2.3c-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.3-1.2 1.1-1.2 2.8s1.2 3.3 1.4 3.5c.2.2 2.4 3.6 5.8 5 .8.3 1.4.5 1.9.7.8.3 1.5.2 2.1.1.6-.1 1.9-.8 2.2-1.5.3-.7.3-1.4.2-1.5-.1-.2-.3-.3-.6-.4z" />
  </svg>
);

export const WhatsAppButton = () => (
  <a
    data-testid="whatsapp-button"
    href={WA_URL}
    target="_blank"
    rel="noreferrer"
    aria-label="Écrire sur WhatsApp"
    className="group fixed bottom-5 right-5 z-40 flex items-center gap-2 rounded-full bg-[#25D366] py-3 pl-3 pr-3 text-white shadow-xl shadow-navy/25 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-2xl hover:pr-5 sm:bottom-7 sm:right-7"
  >
    <WhatsAppIcon />
    <span className="max-w-0 overflow-hidden whitespace-nowrap text-sm font-semibold transition-all duration-300 group-hover:max-w-[160px] sm:max-w-[160px]">
      Écrire sur WhatsApp
    </span>
  </a>
);
